import {
    parseISO, isValid, format, add
} from 'date-fns';
import { dayInMilliseconds } from './constants';

export const getFormattedDateTimeString = (date, locale) => {
    const parsedDate = parseISO(date);

    const dayString = parsedDate.toLocaleDateString(locale, { weekday: 'long' });
    const dateString = parsedDate.toLocaleDateString(locale, { day: 'numeric' });
    const monthString = parsedDate.toLocaleDateString(locale, { month: 'long' });

    return isValid(parsedDate)
    // neither js nor date-fns has support to properly localize and format hence the combination
        ? `${dayString} ${dateString} ${monthString} ${format(parsedDate, ' HH:mm')}`
        : '';
};

export const getDaysFromMilliseconds = milliseconds => Math.floor(milliseconds / dayInMilliseconds);

export const getDateFromAge = age => format(add(new Date(), { years: -age }), 'yyyy-MM-dd');
